import { isNone } from '@ember/utils';
import {
  getActionsWithoutIncomingEdges,
  traverseBranchUntilRejoin,
  arrayContainsEdge,
} from 'cio/utils/visual-workflow-builder/branching';
import { consolidateTree } from 'cio/utils/campaigns/tree-consolidation';

export default function parseTree(edges, actions) {
  let {
    actionMap,
    targetIds,
    consolidatedEdges,
    consolidatedActions,
    consolidatedActionsGroups,
    consolidatedBranchDefaultActions,
    parentConsolidatedBranchMap,
  } = consolidateTree(edges, actions);

  let edgesCopy = [...consolidatedEdges];
  let actionsCopy = [...consolidatedActions];
  let nodesWithoutIncomingEdges = getActionsWithoutIncomingEdges(edgesCopy, actionsCopy);
  let branchTree = [];
  let branches = {};
  let depths = {};
  let parentBranchChains = {};

  let branchRejoinPointsMap = {};
  let parentBranchMap = {};

  let allTraversedActions = [];

  while (nodesWithoutIncomingEdges.length > 0) {
    let traversedEdges = [];
    let traversedActionsMap = {};

    nodesWithoutIncomingEdges.forEach((node) => {
      branchTree.push(
        ...traverseBranchUntilRejoin(node, null, [], traversedActionsMap, traversedEdges, [], branchRejoinPointsMap, {
          actions: consolidatedActions,
          edges: consolidatedEdges,
          actionMap,
          targetIds,
          parentBranchMap,
          branches,
          allTraversedActions,
          depths,
          parentBranchChains,
        }),
      );
    });

    edgesCopy = edgesCopy.filter((edge) => !arrayContainsEdge(traversedEdges, edge));
    actionsCopy = actionsCopy.filter((action) => traversedActionsMap[action.id] == null);

    nodesWithoutIncomingEdges = getActionsWithoutIncomingEdges(edgesCopy, actionsCopy);
  }

  let branchActionIds = consolidatedActions.filter((a) => a.isBranch).mapBy('id');

  // If a branch doesn't have a rejoin point defined, but is nested within
  // another branch, assign it that parent branch's rejoin point. This helps
  // us later determine which nested branches actually terminate and which
  // continue without having to re-traverse the whole tree again.
  // TODO: This is a bit dangerous, because a branch may actually only have
  // exits, and as such should not have a rejoin point set.
  branchActionIds.forEach((id) => {
    if (!isNone(branchRejoinPointsMap[id])) {
      return;
    }

    let parentId = parentBranchMap[id];
    let rejoinPoint = null;

    while (isNone(rejoinPoint) && !isNone(parentId)) {
      rejoinPoint = branchRejoinPointsMap[parentId];
      parentId = parentBranchMap[parentId];
    }

    branchRejoinPointsMap[id] = rejoinPoint;
  });

  allTraversedActions = allTraversedActions.uniqBy('id');

  return {
    branchTree,
    branches,
    branchRejoinPointsMap,
    parentBranchMap,
    traversedActions: allTraversedActions,
    depths,
    parentBranchChains,
    consolidatedEdges,
    consolidatedActions,
    consolidatedActionsGroups,
    consolidatedBranchDefaultActions,
    parentConsolidatedBranchMap,
  };
}
